import { Component, OnInit } from '@angular/core';
import { UserService, ContextService, CommandeService } from '../../shared';
import { EnteteCommande } from '../../shared';

@Component({
  selector: 'app-purchases',
  templateUrl: './purchases.component.html',
  styleUrls: ['./purchases.component.scss'],
  providers: [ CommandeService ]
})
export class PurchasesComponent implements OnInit {

  context: string;
  commandes: Array<any> = [];
  message: string;

  constructor(
  	private userService: UserService,
    private contextService: ContextService,
    private commandeService: CommandeService,
  ) { }

  ngOnInit() {

    this.context = this.contextService.getContext();

    this.commandeService.getAllCommandes()
      .subscribe(
        data => {
          this.process_datas(data)
          
        },
        error => {
           this.message=error[0].Message
          if(error[0].Code == 'COMMANDE_NON_TROUVE'){
            this.commandes = [];
          }
        }
      );
  }

  dateFormat(date: string){
    return new Date(date.replace(/-/g, "/")).toLocaleDateString();
  }

  process_datas(data){
    this.commandes = data;
     this.commandes.forEach((item) => {
           item.opened=false;
       })
  }

  showDetail(item){
    item.opened=!item.opened;

  }

}



// WEBPACK FOOTER //
// ./src/app/user/_purchases/purchases.component.ts